import type { SVGProps } from 'react'
const LineShareIos = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M11.25 14.75V4L9.405 5.845l-1.06-1.06 2.77-2.77a1.26 1.26 0 0 1 1.77 0l2.77 2.77-1.06 1.06L12.75 4v10.75zM14 7h3.25A2.755 2.755 0 0 1 20 9.75v9.5A2.755 2.755 0 0 1 17.25 22H6.75A2.755 2.755 0 0 1 4 19.25v-9.5A2.755 2.755 0 0 1 6.75 7H10v1.5H6.75c-.69 0-1.25.56-1.25 1.25v9.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-9.5c0-.69-.56-1.25-1.25-1.25H14z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineShareIos }
